import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./AuthGuard";
import {
  loadAuthView,
  loadAdminView,
  loadClubView,
  loadLeagueView,
  loadLibView,
  loadRegisterView
} from "./routerHelper";
import Map from "../components/views/common/Map/Map.vue";
import Calendar from "@/components/views/common/Calendar/Calendar.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    // Club Section
    // ************  DON'T MOVE BELOW section below HomeClub until the issue researched and resolved why HomeClub loads by default *****************/
    {
      path: "/renew-athlete",
      name: "RenewAthlete",
      component: loadRegisterView("RenewAthlete"),
      section: "Club",
      description: "Renew an athlete",
      icon: "person_add",
      show: 1
      //requiresClub: true,
    },
    {
      path: "/register-athlete", 
      name: "RegisterAthlete",
      component: loadRegisterView("RegisterAthlete"),
      section: "Club",
      description: "Register an athlete",
      icon: "person_add",
      show: 1
      //requiresClub: true,
    },
    // ************  DON'T MOVE ABOVE SECTION below HomeClub until the issue researched and resolved why HomeClub loads by default *****************/
    {
      path: "/:club",
      name: "HomeClub",
      component: loadClubView("HomeClub"),
      section: "Club",
      description: "Club Home",
      icon: "home",
      requiresClub: true,
      //beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/group",
      name: "Group",
      component: loadClubView("GroupList"),
      section: "Club",
      description: "Groups in the Club",
      icon: "group",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/group_program",
      name: "Group Program",
      component: loadClubView("GroupProgram"),
      section: "Club",
      description: "Groups in the Club",
      icon: "format_list_numbered",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/athlete_list",
      name: "Athlete",
      component: loadClubView("AthleteList"),
      section: "Club",
      description: "List of Athletes",
      icon: "person",
      requiresClub: true,
    },
    {
      path: "/:club/club/athlete_attendance",
      name: "AthleteAttendance",
      component: loadClubView("AthleteAttendance"),
      section: "Club",
      description: "Athlete Attendance",
      icon: "check_circle",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/athlete_results",
      name: "AthleteResults",
      component: loadClubView("AthleteResults"),
      section: "Club",
      description: "Athlete Results",
      icon: "assessment",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/Ranks",
      name: "Athlete Ranks",
      component: loadClubView("AthleteRanksResults"),
      section: "Club",
      description: "Athlete Results & Ranks",
      icon: "assessment",
      requiresClub: true,
      //     beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/etl",
      name: "Upload Files",
      component: () => import("../components/etl/upload_files.vue"),
      section: "Club",
      icon: "cloud_upload",
      description: "Data Upload to platform",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/athlete_performance",
      name: "AthletePerformance",
      component: loadClubView("AthletePerformance"),
      section: "Club",
      description: "Athlete Performance",
      icon: "bar_chart",
      requiresClub: true,
      beforeEnter: AuthGuard
    },
    {
      path: "/:club/club/records",
      name: "Records",
      component: loadLeagueView("Records"),
      section: "Club",
      description: "Athlete Records",
      icon: "timeline",
      requiresClub: true,
    },
    {
      path: "/:club/club/communications",
      name: "Communications",
      component: loadClubView("PersonCommunications"),
      section: "Club",
      description: "PersonCommunications",
      icon: "connect_without_contact",
      requiresClub: true
    },
    {
      path: "/:club/club/messagecenter",
      name: "Message Center",
      component: loadClubView("MessageCenter"),
      section: "Club",
      description: "MessageCenter",
      icon: "contact_phone",
      requiresClub: true
    },
    {
      path: "/:club/club/clubterm",
      name: "Club Term",
      component: loadClubView("ClubTerm"),
      section: "Club",
      description: "Club Term",
      icon: "date_range",
      requiresClub: true
    },
    {
      path: "/:club/club/schedule",
      name: "Workout Schedule",
      component: loadClubView("WorkoutSchedule"),
      section: "Club",
      description: "Workout Schedule",
      icon: "schedule",
      requiresClub: true
    },        
    // League Section
    {
      path: "/:league/league",
      name: "LeagueClub",
      component: loadLeagueView("HomeLeague"),
      section: "League",
      description: "League Homepage",
      icon: "sports_soccer",
      requiresLeague: true,
    },
    {
      path: "/:league/league/records",
      name: "Records",
      component: loadLeagueView("Records"),
      section: "League",
      description: "League Records",
      icon: "timeline",
      requiresLeague: true,
    },
    {
      path: "/:league/league/Ranks",
      name: "Ranks",
      component: loadClubView("AthleteRanksResults"),
      section: "League",
      description: "Athlete Ranks",
      icon: "assessment",
      requiresLeague: true,
    },
    {
      path: "/:league/league/etl",
      name: "Upload Files",
      component: () => import("../components/etl/upload_files.vue"),
      section: "League",
      description: "Upload Files for League",
      icon: "cloud_upload",
      requiresLeague: true,
    },
    {
      path: "/:league/league/report",
      name: "Meet Report",
      component: () => import("../components/views/club/AthleteMeetReport.vue"),
      section: "League",
      description: "Meet Reports",
      icon: "assignment",
      requiresLeague: true,
    },

    // Library Section
    {
      path: "/lib/home_lib",
      name: "HomeLib",
      component: loadLibView("home_lib"),
      section: "Library",
      description: "Library Home",
      icon: "library_books",
    },
    {
      path: "/lib/drill_lib",
      name: "DrillLib",
      component: loadLibView("drill_lib"),
      section: "Library",
      description: "Drill Library",
      icon: "accessibility_new",
    },
    {
      path: "/lib/program",
      name: "Program",
      component: loadLibView("program_lib"),
      section: "Library",
      description: "Programs",
      icon: "format_list_numbered",


      // beforeEnter: AuthGuard
    },
    {
      path: "/lib/sets_lib",
      name: "SetsLib",
      component: loadLibView("sets_lib"),
      section: "Library",
      description: "Sets Library",
      icon: "list",
    },
    {
      path: "/lib/activity_list",
      name: "ActivityList",
      component: loadClubView("ActivityList"),
      section: "Library",
      description: "Activity List",
      icon: "event",
    },
    {
      path: "/lib/rank_lib",
      name: "RankLib",
      component: loadLibView("rank_lib"),
      section: "Library",
      description: "Rank Library",
      icon: "star",
    },
    {
      path: "/lib/standards",
      name: "StandardsLib",
      component: loadLibView("standards_lib"),
      section: "Library",
      description: "Standards Library",
      icon: "check",
    },
    {
      path: "/lib/standardsPivot",
      name: "StandardsPivotLib",
      component: loadLibView("standards_pivot"),
      section: "Library",
      description: "Standards Pivot Table",
      icon: "pivot_table_chart",
    },
    {
      path: "/lib/meets_lib",
      name: "MeetsLib",
      component: loadLibView("meets_lib"),
      section: "Library",
      description: "Meets Library",
      icon: "event_available",
    },
    {
      path: "/lib/category_val",
      name: "Artifacts",
      component: loadLibView("category_val_list"),
      section: "Library",
      description: "Categories and Values List",
      icon: "category",
    },
    {
      path: "/lib/activity_list",
      name: "Energys Zones",
      description: "Energy Zones Matrix",
      component: loadLibView("activity_list"),
      icon: "fitness_center",
      section: "Library",
    },
    // Admin Section
    {
      path: "/admin/leagues",
      name: "Leagues",
      component: loadAdminView("Leagues"),
      section: "Admin",
      description: "List of Leagues",
      icon: "sports_handball",
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/club_list",
      name: "ClubList",
      component: loadAdminView("ClubList"),
      section: "Admin",
      description: "List of Clubs",
      icon: "business",
      beforeEnter: AuthGuard
    },
    {
      path: "/admin/user_list",
      name: "UserList",
      component: loadAdminView("UserList"),
      section: "Admin",
      description: "List of Users",
      icon: "person",
      beforeEnter: AuthGuard
    },


    // Misc Section
    {
      path: "/lib/map",
      name: "Map",
      component: Map,
      section: "Misc",
      description: "Map",
      icon: "map",
    },
    {
      path: "/lib/calendar",
      name: "Calendar",
      component: Calendar,
      section: "Misc",
      description: "Calendar",
      icon: "calendar_today",
    },
    // Authentication Section
    {
      path: "/",
      name: "LandingMain",
      component: loadAuthView("LandingMain"),
      section: "Authentication",
      description: "Landing page for the app",
      icon: "home",
      show: 0,
      beforeEnter: AuthGuard
    },
    {
      path: "/auth/signin",
      name: "Signin",
      component: loadAuthView("SignIn"),
      section: "Authentication",
      description: "User Sign In",
      icon: "login",
      show: 0,
    },
    {
      path: "/auth/signup",
      name: "Signup",
      component: loadAuthView("SignUp"),
      section: "Authentication",
      description: "User Sign Up",
      icon: "person_add",
      show: 0,
    },
    {
      path: "/auth/user_profile",
      name: "Profile",
      component: loadAuthView("Profile"),
      section: "Authentication",
      description: "User Profile",
      show: 0,
      icon: "account_circle",
      beforeEnter: AuthGuard
    },
  ],

  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth"
      };
    }
  }
});
